<div class="sfl-loader" [class.sfl-loader--overlay]="overlay" role="status" [attr.aria-label]="label">
  <span class="sfl-loader__ring" [style.width.px]="size" [style.height.px]="size" [style.borderWidth.px]="strokeWidth"></span>
</div>
